import { NgModule } from '@angular/core';
import { StarsRatingComponent } from './stars-rating.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [StarsRatingComponent],
  imports: [CommonModule, MatIconModule],
  exports: [StarsRatingComponent],
})
export class StarsRatingModule {}
